import { BusLineEffects } from './master-data/busline.effects';
import { CountryEffects } from './master-data/country.effects';
import { PlantEffects } from './master-data/plant.effects';
import { PriceSheetEffects } from './master-data/price.sheet.effects';
import { RegionEffects } from './master-data/region.effects';
import { SupplierEffects } from './master-data/supplier.effects';
import { VehicleEffects } from './master-data/vehicle.effects';
import { BusLineStopEffects } from './master-data/bus-line-stops.effects';
import { BusCheckEffects } from './bus-check-list.effects';

export const effects = [
    CountryEffects,
    PlantEffects,
    RegionEffects,
    SupplierEffects,
    PriceSheetEffects,
    BusLineEffects,
    VehicleEffects,
    BusLineStopEffects,
    BusCheckEffects
];
